import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/globals.css'
import { registerSW } from 'virtual:pwa-register'

// Register service worker (only in production)
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  registerSW({
    immediate: true,
    onRegistered(r: any) {
      console.log('ServiceWorker registration successful:', r)
    },
    onRegisterError(error: any) {
      console.error('ServiceWorker registration failed:', error)
    }
  })
}

// iOS standalone mode detection
if (window.matchMedia('(display-mode: standalone)').matches) {
  document.documentElement.classList.add('standalone')
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)